export * from './openlayers-map.component';
export * from './openlayers-map';




// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/open-layers-map/openlayers-map/index.ts